'use client'

import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import NonMemberModal from '@/components/Shared/NonMemberModal'
import MessageAfterLogin from '@/components/Shared/MessageAfterLogin'
import { useNavigationState } from '@/hooks/useNavigationState'
import { useAuth } from '@/hooks/useAuth'
import styles from './styles.module.scss'

export default function DefaultLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const { beforePath, removeBeforePath } = useNavigationState()
  const { getMemberId } = useAuth()

  const isReportPath = pathname?.indexOf('/reports/') > 0
  const bottomFixedButton = ['companyId', 'members'].includes(getRouteName(pathname))
  const bookshelfPath = getRouteName(pathname) === 'members-bookshelf'
  const displayNav = getRouteName(pathname) !== 'index'
  const isPreviewPath = (): boolean => (pathname || '').startsWith('/preview/')
  // 記事ページ判定（SP時に既存Headerを非表示にするため）
  const isArticlePage =
    isPreviewPath() || /^\/[^/]+\/(stories|knowhows)\/[^/]+\/?$/.test(pathname || '')

  useEffect(() => {
    // Set viewport height variable
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)

    const currentPathName = getRouteName(pathname)

    // removeStorageの除外ページ
    const excludeNames = ['login', 'members-activate-id']

    // 現在のパスが excludeNames 以外の場合にのみ クリア処理を実行
    if (beforePath && !excludeNames.includes(currentPathName)) {
      removeBeforePath()
    }
  }, [pathname, beforePath, removeBeforePath])

  function getRouteName(path: string | null): string {
    if (!path) return ''
    const segments = path.split('/')
    return segments[segments.length - 1] || 'index'
  }

  function getContainerClassName(): string {
    const classNames = ['all_container']

    if (isReportPath) classNames.push('report')
    if (bottomFixedButton) classNames.push('bottom-fixed')
    if (bookshelfPath) classNames.push('bookshelf-wrapper')
    if (isPreviewPath()) classNames.push('preview')

    return classNames.join(' ')
  }

  return (
    <div className={getContainerClassName()}>
      {isPreviewPath() && (
        <div className='previewHeader'>
          <div className='previewText'>プレビュー画面</div>
        </div>
      )}
      <div
        id='main-container'
        className={clsx('main-container', { 'no-category-nav': !displayNav })}
      >
        <div className={clsx({ [styles.hideOnSpArticle]: isArticlePage })}>
          <Header />
        </div>
        <div id='app' className={styles.appContainer}>
          {children}
        </div>
        <NonMemberModal />
        <MessageAfterLogin memberId={getMemberId()} />
        <Footer />
      </div>
    </div>
  )
}
